'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reducer;
exports.getContactInfoRequestStart = getContactInfoRequestStart;
exports.getContactInfoRequestSuccess = getContactInfoRequestSuccess;
exports.getContactInfoRequestFail = getContactInfoRequestFail;
exports.getContactInfoRequest = getContactInfoRequest;
exports.updateContactList = updateContactList;
exports.contactNetworkStatusChange = contactNetworkStatusChange;
exports.getContactDetails = getContactDetails;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _helpers = require('../../common/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// actions
var GET_CONTACT_INFO_REQUEST_START = "contact-info-request-start";
var GET_CONTACT_INFO_REQUEST_SUCCESS = "contact-info-request-success";
var GET_CONTACT_INFO_REQUEST_FAIL = "contact-info-request-fail";
var UPDATE_CONTACTS_LIST = "update-contact-info";
var CONTACT_NETWORK_STATUS_CHANGE = "contact-network-status-change";

var initialState = { contacts: [], isFetching: false, contactsFetchSuccess: null };
var checkContactExist = function checkContactExist(newContact, contactList) {
    var found = contactList.some(function (contact) {
        return contact.id === newContact.id;
    });
    return found;
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var contactIndex = void 0;

    switch (action.type) {
        case GET_CONTACT_INFO_REQUEST_START:
            return Object.assign({}, initialState, { isFetching: true });

        case GET_CONTACT_INFO_REQUEST_SUCCESS:
            console.log("inside.. contacts info req success...");
            console.log("action.payload of success", action.payload);
            // Set initial contact list of the user
            var contacts = action.payload;
            return Object.assign({}, state, { contacts: contacts, isFetching: false, contactsFetchSuccess: true });

        case GET_CONTACT_INFO_REQUEST_FAIL:
            console.log("inside contacts info request failure,...");
            return Object.assign({}, state, { isFetching: false, contactsFetchSuccess: false });

        case UPDATE_CONTACTS_LIST:
            var contactList = [].concat(_toConsumableArray(state.contacts));
            action.payload.map(function (contact) {
                if (!checkContactExist(contact, contactList)) {
                    contactList.push(contact);
                }
                return '';
            });
            return Object.assign({}, state, { contacts: contactList });

        case CONTACT_NETWORK_STATUS_CHANGE:
            contacts = [].concat(_toConsumableArray(state.contacts));
            contactIndex = contacts.map(function (contact) {
                return contact.id;
            }).indexOf(action.payload.user_id);
            if (contactIndex >= 0) contacts[contactIndex].online_status = action.payload.is_online;
            return Object.assign({}, state, { contacts: contacts });

        default:
            return state;
    }
}

// action creators
function getContactInfoRequestStart(getContactInfoRequestStartState) {
    return {
        type: GET_CONTACT_INFO_REQUEST_START,
        payload: getContactInfoRequestStartState,
        receivedAt: Date.now()
    };
}

function getContactInfoRequestSuccess(getContactInfoRequestSuccessState) {
    return {
        type: GET_CONTACT_INFO_REQUEST_SUCCESS,
        payload: getContactInfoRequestSuccessState,
        receivedAt: Date.now()
    };
}

function getContactInfoRequestFail(getContactInfoRequestFailState) {
    return {
        type: GET_CONTACT_INFO_REQUEST_FAIL,
        payload: getContactInfoRequestFailState,
        receivedAt: Date.now()
    };
}

// thunk action creator
function getContactInfoRequest(userId) {
    return function (dispatch) {
        dispatch(getContactInfoRequestStart({ userId: userId }));

        var timeout = new Promise(function (resolve, reject) {
            setTimeout(reject, 3000, { status: "fail", message: "Request timed out" });
        });

        var request = new Promise(function (resolve, reject) {
            var contactUrl = window.sfChat.baseApiUrl + "/v1/contact/list";
            var headers = (0, _helpers.getAuthHeader)();
            (0, _isomorphicFetch2.default)(contactUrl, {
                method: 'GET',
                headers: headers
            }).then(function (response) {
                return response.json();
            }).then(function (res) {
                return resolve(res);
            }).catch(function (e) {
                return reject(e);
            });
        });

        return Promise.race([timeout, request]).then(function (res) {
            console.log("contacts api response.. : ", res);
            res.status === "success" ? dispatch(getContactInfoRequestSuccess(res.data)) : dispatch(getContactInfoRequestFail({ error_msg: "Invalid User ID" }));
        }).catch(function (err) {
            console.log("loginRequest::catch:", err);
            var res = { status: "fail", data: { error_msg: err.message } };
            dispatch(getContactInfoRequestFail(res.data));
        });
    };
}

function updateContactList(contacts) {
    return {
        type: UPDATE_CONTACTS_LIST,
        payload: contacts,
        receivedAt: Date.now()
    };
}

function contactNetworkStatusChange(payload) {
    return {
        type: CONTACT_NETWORK_STATUS_CHANGE,
        payload: payload
    };
}

function getContactDetails(user_id) {
    return function (dispatch, getState) {
        var contacts = getState().contacts.contacts;

        var contactDetails = contacts.find(function (contact) {
            return contact.id === user_id;
        });

        return contactDetails;
    };
}


// WEBPACK FOOTER //
// ../chat/lib/components/contacts/contact_reducer.js